<form
    [formGroup]="shareSettings"
    class="share-form"
    *transloco="let t; read: 'sharePanel'"
>
    <h1 class="share-form__heading">{{ t('shareSettings') }}</h1>

    <div class="share-form__field share-form__selector" formGroupName="privacyLevel" [@fadeIn]="settingsLoaded">
      <div class="component-background">
        <p-selectButton
          [options]="privacyOptions"
          formControlName="level"
          optionLabel="name"
          optionValue="code"
          styleClass="p-buttonset--dark"
        >
          <ng-template let-option pTemplate="item">
            <div class="p-button-label"
                 pTooltip="{{ option.disabled ? t(option.disabledReason) : '' }}"
                 tooltipPosition="top"
                 [tooltipDisabled]="!option.disabled"
                 style="pointer-events: auto;">
              <svg-icon
                [ngStyle]="{'font-size' : option.code === 'CUSTOM' ? '1.5em' : '1em'}"
                [key]="option.icon">
              </svg-icon>
              <span>{{ t(option.name) }}</span>
            </div>
          </ng-template>
        </p-selectButton>
      </div>
    </div>

    <bulb-share-toggle-text [privacySetting]="shareSettings.valueChanges"
                            [@fadeIn]="settingsLoaded"></bulb-share-toggle-text>

    <div [@fadeIn]="settingsLoaded">
      <section *ngIf="shareSettings.controls['privacyLevel'].value.level === 'PRIVATE'">
        <img src="resources/images/share-panel/just-me.svg" alt="a drawing of..." class="just-me-img">
      </section>

      <section *ngIf="shareSettings.controls['privacyLevel'].value.level !== 'PRIVATE'" @fadeIn>
          <div *ngIf="publishingFeature.userPublishing" class="share-form__field">
            <label class="share-form__label">{{ t('shareWithUsers') }}</label>
            <bulb-modal-select-input
              [placeholder]="'sharePanel.shareWithUsersPlaceholder'"
              [formControlName]="'permissions'"
            ></bulb-modal-select-input>
          </div>

          <div *ngIf="publishingFeature.organizationPublishing || publishingFeature.groupPublishing"  class="share-form__field">
            <label class="share-form__label">{{ t('shareWithGroups') }}</label>
            <bulb-modal-select-input
              [parentUnitId]="parentUnitId"
              [compositeUnit]="compositeUnit"
              [placeholder]="'sharePanel.shareWithGroupsYouAreIn'"
              searchSubjectType="BULB_GROUP"
              [formControlName]="'permissions'"
            ></bulb-modal-select-input>
          </div>
      </section>
    </div>
</form>

<div class="share-social-section" [@fadeIn]="settingsLoaded">
  <section *ngIf="shareSettings.controls['privacyLevel'].value.level !== 'PRIVATE'">
    <bulb-private-share-link *ngIf="sharingFeature.privateLinks"
                             [unitId]="unitId"
                             [shareUrl]="shareSettings.controls['privateShareLink'].value"
    ></bulb-private-share-link>

    <bulb-social-share
      [disabledShareLink]="!sharingFeature.privateLinks"
      [socialPlatformsDisabledByOrg]="!sharingFeature.socialSharing"
      [shareUrl]="shareSettings.getRawValue().privateShareLink"
      [socialPlatformsDisabledByShareState]="sharingFeature.socialSharing && shareSettings.getRawValue().privacyLevel.level === 'CUSTOM'"
      [isFreeUser]="isFreeUser"
    ></bulb-social-share>
  </section>
</div>
